import dayjs from "dayjs";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useAppSelector } from "store/store";
import {
  GET_ALL_FAVORITE_UPLOAD,
  GET_COMPANY_LIST,
  TRANSACTION_UPLOAD_CONTRACT_NOTE,
} from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { handleDowloadFile } from "utils/fileHelper";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

export const useUploadmanager = ({ isApproveModal, fileData }: any) => {
  const userInfo = useAppSelector((state) => state?.user?.userData);

  const portfolios = useAppSelector((state) => state?.app?.portfolios);

  const [selectedIndex, setSelectedIndex] = useState<any[]>([]);

  const [selectedId, setSelectedId] = useState(null);

  const [showFavoriteModal, setShowFavoriteModal] = useState(false);

  const [isPortfolioCreateModalOpen, setIsPortfolioCreateModalOpen] =
    useState<boolean>(false);

  const [allFiles, setAllFiles] = useState([]);

  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const form = useForm({
    defaultValues: {
      date: "",
      file: [],
      fileType: "",
      sheetTypeId: "",
      filePassword: "",
      favoriteType: "",
      fileIndex: null,
      fileObject: null,
      nullCompanies: [],
      nullPortfolios: [],
      sheetTypeName: "",
      fileUploadType: "",
      fileBrokerType: "",
      fileVersion: "",
      isNewTemplate: false,
      sampleAvailable: false,
      fileUploadResponse: null,
      fileReviewResponse: null,
      activeStep: 0,
      templatesTabs: 0,
    },
  });
  form.watch();

  const activeStepWatch = form.watch("activeStep");
  const templatesTabspWatch = form.watch("templatesTabs");
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleReset = () => {
    form.setValue("activeStep", 0);
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleNext = () => {
    form.setValue("activeStep", activeStepWatch + 1);
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handleSheetReviewComplete,
    isLoading: handleSheetReviewCompleteLoading,
  } = useMutation({
    mutationFn: (selectedIds) =>
      axiosInstance.post(
        `${form.getValues("fileObject.reviewUrlPath")}?commit=true&id=${form.getValues("fileUploadResponse.id")}`,
        {
          duplicates_ids: selectedIds,
        },
      ),
    onSuccess: (response: any) => {
      form.setValue("activeStep", 6);
      setAllFiles(
        allFiles?.map((item) => {
          return {
            ...item,
            inProgress:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? true
                : item?.finished,
            finished:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? true
                : item?.finished,
            data:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? response?.data?.data
                : item?.data,
          };
        }),
      );
      refetchQuery(QueryKeys.UPLOAD_MANAGER_LIST);
    },
    onError: (error: any) => {
      setAllFiles(
        allFiles?.map((item) => {
          return {
            ...item,
            inProgress:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? true
                : item?.finished,
            finished:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? true
                : item?.finished,
            hasError:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? true
                : item?.hasError,
            status:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? "failed"
                : item?.status,
            message:
              item?.data?.id === form.getValues("fileUploadResponse.id")
                ? error?.response?.data?.message
                : item?.message,
          };
        }),
      );
      refetchQuery(QueryKeys.UPLOAD_MANAGER_LIST);
      form.setValue("activeStep", 1);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { mutate: handleSheetReview, isLoading: handleSheetReviewLoading } =
    useMutation({
      mutationFn: (documentId) =>
        axiosInstance.post(
          `${form.getValues("fileObject.reviewUrlPath")}?id=${documentId}`,
        ),
      onSuccess: (reviewApiResponse: any) => {
        setSelectedIndex(
          reviewApiResponse?.data?.transactions
            ?.filter((d: any) => !d?.isDuplicate)
            ?.map((item: any) => item?.id),
        );
        setAllFiles(
          allFiles?.map((item, index) => {
            return {
              ...item,
              inProgress:
                index === form.getValues("fileIndex")
                  ? false
                  : item?.inProgress,
              finished:
                index === form.getValues("fileIndex") ? true : item?.finished,
              data:
                index === form.getValues("fileIndex")
                  ? reviewApiResponse?.data
                  : item?.data,
            };
          }),
        );
        refetchQuery(QueryKeys.UPLOAD_MANAGER_LIST);
        form.setValue("fileReviewResponse", {
          ...reviewApiResponse?.data,
          transactions: reviewApiResponse?.data?.transactions?.map(
            (data: any) => {
              return { ...data };
            },
          ),
        });
      },
      onError: (error: any) => {
        setAllFiles(
          allFiles?.map((item, index) => {
            return {
              ...item,
              hasError:
                index === form.getValues("fileIndex") ? true : item?.hasError,
              finished:
                index === form.getValues("fileIndex") ? true : item?.finished,
              status:
                index === form.getValues("fileIndex") ? "failed" : item?.status,
              message:
                index === form.getValues("fileIndex")
                  ? error?.response?.data?.message
                  : item?.message,
            };
          }),
        );
        form.setValue("activeStep", 1);
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong, please try again.",
        );
      },
    });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handlePostCompanyMapping,
    isLoading: handlePostCompanyMappingLoading,
  } = useMutation({
    mutationFn: (values) =>
      axiosInstance.post(`/advisor-company-mappings/`, values),
    onSuccess: () => {
      handleNext();
      handleSheetReview(form.getValues("fileUploadResponse.id"));
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handleGetCompanyMapping,
    isLoading: handleGetCompanyMappingLoading,
  } = useMutation({
    mutationFn: (documentId: any) =>
      axiosInstance.get(
        `${form.getValues("fileObject.companyMappingUrlPath")}?id=${documentId}`,
      ),
    onSuccess: (companyMappingResponse: any) => {
      const companies = companyMappingResponse?.data?.data?.filter(
        (data: any) => data?.value === null,
      );
      form.setValue("nullCompanies", companies);
      if (companies?.length !== 0) {
        form.setValue("activeStep", 3);
      } else {
        form.setValue("activeStep", 4);
        handleSheetReview(form.getValues("fileUploadResponse.id"));
      }
    },
    onError: (error: any) => {
      setAllFiles(
        allFiles?.map((item, index) => {
          return {
            ...item,
            hasError:
              index === form.getValues("fileIndex") ? true : item?.hasError,
            finished:
              index === form.getValues("fileIndex") ? true : item?.finished,
          };
        }),
      );
      form.setValue("activeStep", 1);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handlePostPortfolioMapping,
    isLoading: handlePostPortfolioMappingLoading,
  } = useMutation({
    mutationFn: (values: any) =>
      axiosInstance.post(
        `${form.getValues("fileObject.portfolioMappingUrlPath")}?id=${form.getValues("fileUploadResponse.id")}`,
        values,
      ),
    onSuccess: () => {
      if (form.getValues("fileObject.companyMapping")) {
        handleNext();
        handleGetCompanyMapping(form.getValues("fileUploadResponse.id"));
      } else {
        form.setValue("activeStep", 4);
        handleSheetReview(form.getValues("fileUploadResponse.id"));
      }
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handleGetPortfolioMapping,
    isLoading: handleGetPortfolioMappingLoading,
  } = useMutation({
    mutationFn: (documentId: any) =>
      axiosInstance.get(
        `${form.getValues("fileObject.portfolioMappingUrlPath")}?id=${documentId}`,
      ),
    onSuccess: (mappingResponse: any) => {
      const portfolios = mappingResponse?.data?.data?.filter(
        (data: any) => data?.portfolio === null,
      );
      form.setValue("nullPortfolios", portfolios);
      setAllFiles(
        allFiles?.map((item, index) => {
          return {
            ...item,
            data:
              index === form.getValues("fileIndex")
                ? form.getValues("fileUploadResponse.id")
                : item?.data,
          };
        }),
      );
      if (portfolios?.length !== 0) {
        form.setValue("activeStep", 2);
      } else if (form.getValues("fileObject.companyMapping")) {
        handleNext();
        handleGetCompanyMapping(form.getValues("fileUploadResponse.id"));
      } else {
        form.setValue("activeStep", 4);
        handleSheetReview(form.getValues("fileUploadResponse.id"));
      }
    },
    onError: (error: any) => {
      setAllFiles(
        allFiles?.map((item, index) => {
          return {
            ...item,
            hasError:
              index === form.getValues("fileIndex") ? true : item?.hasError,
            finished:
              index === form.getValues("fileIndex") ? true : item?.finished,
            status:
              index === form.getValues("fileIndex") ? "failed" : item?.status,
            message:
              index === form.getValues("fileIndex")
                ? error?.response?.data?.message
                : item?.message,
          };
        }),
      );
      form.setValue("activeStep", 1);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    mutate: handleFileSubmission,
    isLoading: handleFileSubmissionLoading,
  } = useMutation({
    mutationFn: ({ formData }: { formData: FormData; fileIndex: number }) =>
      axiosInstance.post(form.getValues("fileObject.urlPath"), formData),
    onSuccess: (
      response: any,
      variables: { formData: FormData; fileIndex: number },
    ) => {
      form.setValue("fileUploadResponse", response?.data);
      if (form.getValues("fileObject.portfolioMapping")) {
        handleGetPortfolioMapping(response?.data?.id);
      } else {
        setAllFiles(
          allFiles?.map((item, index) => {
            return {
              ...item,
              finished: index === variables.fileIndex ? true : item?.finished,
              status:
                index === variables.fileIndex ? "Completed" : item?.status,
              data: index === variables.fileIndex ? response?.data : item?.data,
            };
          }),
        );
        setSelectedIndex(
          response?.data?.transactions
            ?.filter((d: any) => !d?.isDuplicate)
            ?.map((item: any) => item?.id),
        );
        form.setValue("fileReviewResponse", {
          transactions: response?.data?.map((data: any, index: number) => {
            return {
              ...data,
              id: index,
            };
          }),
        });
        form.setValue("activeStep", 4);
      }
    },
  });

  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { data: menuOptions } = useFetchQuery({
    key: [QueryKeys.UPLOAD_MANAGER_SELECT_OPTIONS],
    route: TRANSACTION_UPLOAD_CONTRACT_NOTE,
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const {
    data: favoriteUploadSamples,
    refetch: favoriteRefetch,
    isFetching: facLoading,
  } = useFetchQuery({
    key: [QueryKeys.UPLOAD_MANAGER_FAVORITE_SAMPLES],
    route: GET_ALL_FAVORITE_UPLOAD,
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const downloadSingleRowErrors = async (id: number, filename: string) => {
    const exactFileName = filename.split(".csv")[0];

    await axiosInstance
      ?.get(`/transaction_upload/${id}/download_errors/?full=false`)
      .then((response: any) => {
        handleDowloadFile({
          fileData: response.data,
          applicaionType: "text/csv",
          fileName: `${exactFileName}.csv`,
          extensionType: "csv",
        });
      })
      .catch((response: any) => {
        const error = response?.json();
        toast.error(error?.message || "Something went wrong");
      });
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleModalTitle = (step: number) => {
    switch (step) {
      case 0:
        return { form: "", title: "Import" };
      case 1:
        return { form: "", title: "Multiple Form" };
      case 2:
        return { form: "portfolio-mapping-form", title: "Portfolio Mapping" };
      case 3:
        return { form: "company-mapping-form", title: "Company Mapping" };
      case 4:
        return {
          form: "review-completed-form",
          title: "Review imported data ",
        };
      case 5:
        return { form: "", title: "Transaction Completed" };

      default:
        return { form: "", title: "Import Manager" };
    }
  };

  const getCompanyListRoute = (fileUploadType: string) => {
    switch (fileUploadType) {
      case "MF":
        return GET_COMPANY_LIST(["MF"]);
      case "STOCK":
        return GET_COMPANY_LIST(["EQ", "ETF"]);
      case "FNO":
        return GET_COMPANY_LIST(["FNO"]);
      case "AIF":
        return GET_COMPANY_LIST(["AIF"]);
      case "PEQ":
        return GET_COMPANY_LIST(["PEQ"]);
      default:
        return GET_COMPANY_LIST(["EQ", "ETF"]);
    }
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { data: companyNames } = useFetchQuery({
    key: [QueryKeys.COMPANY_NAMES, form.getValues("fileUploadType")],
    enabled: !!form.getValues("fileUploadType"),
    // route:
    //   form.getValues("fileUploadType") === "MF" ||
    //   form.getValues("fileUploadType") === "PEQ"
    //     ? GET_COMPANY_LIST([form.getValues("fileUploadType")])
    //     : GET_COMPANY_LIST(),
    route: getCompanyListRoute(form.getValues("fileUploadType")),

    staleTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: true,
    requestBody: {},
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleReturnSize = (file: any) => {
    const totalBytes = file?.size;
    if (totalBytes < 1000000) {
      return `${(totalBytes / 1000).toFixed(2)}KB`;
    }
    return `${(totalBytes / 1000000).toFixed(2)}MB`;
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleReviewPortfolio = async (data: any) => {
    await axiosInstance
      ?.post(`/client/upload/?commit=true`, {
        clients_data: data,
      })
      .then((response) => {
        setAllFiles(
          allFiles?.map((item) => {
            return {
              ...item,
              inProgress:
                item?.data?.id === form.getValues("fileUploadResponse.id")
                  ? true
                  : item?.finished,
              finished:
                item?.data?.id === form.getValues("fileUploadResponse.id")
                  ? true
                  : item?.finished,
              data:
                item?.data?.id === form.getValues("fileUploadResponse.id")
                  ? response?.data?.data
                  : item?.data,
            };
          }),
        );
        form.setValue("activeStep", 6);
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong, please try again.",
        );
      });
  };

  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { mutate: handleDeleteFav } = useMutation({
    mutationFn: (values: { id: number; type: string }) =>
      axiosInstance.delete(
        `/transaction_upload/${values?.id}/delete_template/?type=${values?.type}`,
      ),
    onSuccess: () => {
      favoriteRefetch();
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { mutate: handleAddToFav } = useMutation({
    mutationFn: (values: { id: number; type: string }) =>
      axiosInstance.post(
        `/transaction_upload/${values?.id}/make_default/?type=${values?.type}`,
      ),
    onSuccess: () => {
      favoriteRefetch();
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleCheckPassword = async (data: any) => {
    const res = await Promise.all(
      data?.map(async (dataItem: any, index: any) => {
        const appendedFiles = new FormData();
        appendedFiles.append("files", dataItem?.file);
        appendedFiles.append("index", index);
        const response = await axiosInstance.post(
          `/auto-forward-password/check_password/`,
          appendedFiles,
        );
        return {
          ...dataItem,
          hasPassword:
            index === Number(response?.data?.data?.index)
              ? response?.data?.data?.isPasswordProtected
              : data?.hasPassword,
        };
      }),
    );
    setAllFiles(res);
  };
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleCheckDate = async (data: any) => {
    const res = await Promise.all(
      data?.map(async (dataItem: any, index: any) => {
        const appendedFiles = new FormData();
        appendedFiles.append("files", dataItem?.file);
        appendedFiles.append("index", index);
        const response = await axiosInstance.post(
          `/auto-forward-password/check_password/?selection=MOTILAL__XLSX_BULK__V0`,
          appendedFiles,
        );
        return {
          ...dataItem,
          isDateRequired:
            index === Number(response?.data?.data?.index)
              ? response?.data?.data?.isDateRequired
              : data?.isDateRequired,
          date:
            index === Number(response?.data?.data?.index)
              ? response?.data?.data?.date
              : data?.date,
        };
      }),
    );
    setAllFiles(res);
  };

  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const isLoading =
    handleSheetReviewLoading ||
    handleGetCompanyMappingLoading ||
    handlePostCompanyMappingLoading ||
    handleSheetReviewCompleteLoading ||
    handleGetPortfolioMappingLoading ||
    handlePostPortfolioMappingLoading ||
    handleFileSubmissionLoading;
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  useEffect(() => {
    if (isApproveModal) {
      setAllFiles([{ data: fileData, isFinished: false, inProgress: true }]);

      form.setValue("activeStep", 1);
      form.setValue("fileIndex", 0);
      form.setValue("fileUploadType", "MF");
      form.setValue("fileObject", fileData);
      form.setValue("fileObject", fileData);
      form.setValue("fileObject", fileData);
      form.setValue("file", [
        { data: fileData, isFinished: false, inProgress: true },
      ]);
      const appendedFiles = new FormData();
      appendedFiles.append(
        form.getValues("fileUploadType") === "Portfolio" ? "file" : "files",
        fileData,
        fileData.name,
      );
      const formatedDate = dayjs(form.getValues("date")).format("YYYY-MM-DD");
      appendedFiles.append("password", form.getValues("filePassword"));
      appendedFiles.append("date", formatedDate);
      setTimeout(() => {
        handleFileSubmission({
          formData: appendedFiles,
          fileIndex: 0,
        });
      }, 100);
    }
  }, [isApproveModal]);

  return {
    isLoading,
    handleReset,
    handleModalTitle,
    favoriteUploadSamples,
    setShowFavoriteModal,
    menuOptions,
    portfolios,
    isPortfolioCreateModalOpen,
    setIsPortfolioCreateModalOpen,
    companyNames,
    userInfo,
    showFavoriteModal,
    favoriteRefetch,
    downloadSingleRowErrors,
    handleDeleteFav,
    form,
    handleAddToFav,
    facLoading,
    handleNext,
    allFiles,
    setAllFiles,
    handleCheckPassword,
    selectedId,
    setSelectedId,
    handleCheckDate,
    handleReturnSize,
    setSelectedIndex,
    selectedIndex,
    handleReviewPortfolio,
    handleFileSubmission,
    handlePostPortfolioMapping,
    handlePostCompanyMapping,
    handleSheetReviewComplete,
    activeStepWatch,
    templatesTabspWatch,
  };
};
